export type SentimentType = 'positive' | 'neutral' | 'negative'

export const colorMap: Readonly<{
  [key in SentimentType]: string
}> = {
  positive: '#5227CC',
  neutral: '#FF7E21',
  negative: '#FF0051',
}

export const sentimentLabels: Readonly<{ [key in SentimentType]: string }> = {
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
}

export type TimelineItem = {
  avgSentiment: number
  timestamp: number
}

export type ParticipantSentiment = {
  timeline: TimelineItem[]
  sentiment: number
  distribution: SentimentDistribution
}
export type SentimentDistribution = {
  [key in SentimentType]: number
}

export type SentimentAnalysisMetadata = {
  sentimentAnalysis:
    | {
        overall: number
        distribution: SentimentDistribution
        participants: {
          [key: string]: ParticipantSentiment
        }
      }
    | { [key: string]: any }
}
